






































import {
  AdvisorNavigation,
  Component,
  Prop,
  Question,
  SectionType,
  Vue
} from "@zoovu/runner-browser-api";
import {Getter} from "vuex-class";
import {PagesNavigationView} from "@zoovu/runner-web-design-base";
import {isScrollingDisabledThroughDataAttribute} from "@zoovu/runner-web-design-base/src/plugins/data-attributes-reader/webdesign-context";
import {scrollToElement} from "@/helpers/utils";
import PageSelectorSlider from "./page-selector-slider.vue";
import QuestionValidationMessageViewExtended from "./question-validation-message.vue";

@Component({
  name: "PageNavigationView",
  mixins: [PagesNavigationView],
  components: {
    PageSelectorSlider,
    QuestionValidationMessageViewExtended
  }
})
export default class PagesNavigationViewExtended extends Vue {
  @Prop()
  navigation!: AdvisorNavigation;

  @Prop()
  question!: Question;

  get isResultsSectionNext(): boolean {
    return (
      this.isQuestionnaire &&
      !this.navigation.currentSection.navigation.hasNext &&
      this.navigation.currentSection.navigation.hasPrevious &&
      this.navigation.currentSection.navigation.currentStepIndex !== 0 &&
      this.navigation.nextSectionType === SectionType.RESULTS_PAGE &&
      this.isResultSectionNextForDynamicFlow()
    );
  }

  @Getter
  scrollMarginTop!: number;

  async scrollToTop(): Promise<void> {
    if (
      !this.$root.$el ||
      !this.answersConfiguration.scrollToTop ||
      isScrollingDisabledThroughDataAttribute
    )
      return;
    await this.$nextTick();
    const leadGen = this.$root.$el.querySelector(".multi-answer");
    const errorMessage = this.$root.$el.querySelector(".question-validation-message");
    scrollToElement(
      ((leadGen && errorMessage) as Element) || (this.$root.$el as Element),
      this.scrollMarginTop
    );
  }

  get isPreviousButtonClickable(): object {
    const isDisabled = !this.navigation.hasPrevious;
    const clickableClass = !this.navigation.hasPrevious ? "noClickableButton" : {};
    return {isDisabled, clickableClass};
  }

  get isNextButtonClickable(): object {
    let clickableClass = "";
    let isDisabled = false;
    if (this.isResultsSectionNext) {
      clickableClass =
        this.submitIsInProgress || this.wouldNotPassValidation || !this.navigation.hasNext
          ? "noClickableButton"
          : "";
      isDisabled = !this.navigation.hasNext;
    } else {
      clickableClass =
        !this.navigation.hasNext || (this.question.isMandatory && this.question.isUnanswered)
          ? "noClickableButton"
          : "";
      isDisabled =
        !this.navigation.hasNext || (this.question.isMandatory && this.question.isUnanswered);
    }
    return {isDisabled, clickableClass};
  }
}
